// HKDSE Mathematics Paper 2 - Remaining Questions (6-30)
// 香港中學文憑考試 數學科 試卷2 剩餘題目

export const paper2RemainingQuestions = [
  {
    id: 6,
    question: "在圓形中，若半徑為 \\(r = 5\\) cm，求圓的面積：",
    questionEn: "In a circle with radius \\(r = 5\\) cm, find the area:",
    svgDiagram: `
      <svg width="200" height="200" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="60" fill="rgba(59, 130, 246, 0.2)" stroke="#3b82f6" stroke-width="3"/>
        <line x1="100" y1="100" x2="160" y2="100" stroke="#ef4444" stroke-width="2"/>
        <text x="130" y="95" font-size="14" fill="#ef4444">r = 5</text>
        <circle cx="100" cy="100" r="3" fill="#10b981"/>
        <text x="105" y="105" font-size="12">圓心</text>
      </svg>
    `,
    options: ["\\(25\\pi\\) cm²", "\\(10\\pi\\) cm²", "\\(5\\pi\\) cm²", "\\(\\pi\\) cm²"],
    correctAnswer: 0,
    explanation: "圓面積公式：\\(A = \\pi r^2 = \\pi \\times 5^2 = 25\\pi\\) cm²",
    explanationEn: "Circle area formula: \\(A = \\pi r^2 = \\pi \\times 5^2 = 25\\pi\\) cm²",
    difficulty: "easy",
    topic: "圓的性質",
    hasMath: true,
    hasSvg: true
  },
  {
    id: 7,
    question: "在 30-60-90 直角三角形中，若斜邊長度為 10，求短邊長度：",
    questionEn: "In a 30-60-90 right triangle, if the hypotenuse is 10, find the length of the shorter leg:",
    svgDiagram: `
      <svg width="250" height="200" viewBox="0 0 250 200">
        <polygon points="50,150 200,150 200,63" fill="none" stroke="#3b82f6" stroke-width="2"/>
        <path d="M 185 150 L 185 135 L 200 135" fill="none" stroke="#3b82f6" stroke-width="1"/>
        <text x="125" y="170" text-anchor="middle" font-size="14">5√3</text>
        <text x="210" y="105" text-anchor="middle" font-size="14">5</text>
        <text x="120" y="100" text-anchor="middle" font-size="14">10</text>
        <path d="M 70 150 A 20 20 0 0 0 85 135" fill="none" stroke="#ef4444" stroke-width="2"/>
        <text x="65" y="140" font-size="12" fill="#ef4444">30°</text>
        <path d="M 180 135 A 15 15 0 0 0 185 120" fill="none" stroke="#10b981" stroke-width="2"/>
        <text x="175" y="125" font-size="12" fill="#10b981">60°</text>
      </svg>
    `,
    options: ["\\(5\\)", "\\(5\\sqrt{3}\\)", "\\(10\\)", "\\(\\frac{10}{3}\\)"],
    correctAnswer: 0,
    explanation: "在 30-60-90 三角形中，邊長比例為 \\(1 : \\sqrt{3} : 2\\)。若斜邊為 10，短邊為 \\(\\frac{10}{2} = 5\\)",
    explanationEn: "In a 30-60-90 triangle, the side ratio is \\(1 : \\sqrt{3} : 2\\). If hypotenuse is 10, shorter leg is \\(\\frac{10}{2} = 5\\)",
    difficulty: "medium",
    topic: "特殊三角形",
    hasMath: true,
    hasSvg: true
  },
  {
    id: 8,
    question: "向量 \\(\\vec{a} = (3, 4)\\) 的長度（模）是：",
    questionEn: "The magnitude (length) of vector \\(\\vec{a} = (3, 4)\\) is:",
    svgDiagram: `
      <svg width="250" height="200" viewBox="0 0 250 200">
        <line x1="30" y1="170" x2="220" y2="170" stroke="#666" stroke-width="1"/>
        <line x1="50" y1="30" x2="50" y2="190" stroke="#666" stroke-width="1"/>
        <defs>
          <marker id="arrowhead2" markerWidth="10" markerHeight="7" refX="10" refY="3.5" orient="auto">
            <polygon points="0 0, 10 3.5, 0 7" fill="#ef4444"/>
          </marker>
        </defs>
        <line x1="50" y1="170" x2="110" y2="90" stroke="#ef4444" stroke-width="3" marker-end="url(#arrowhead2)"/>
        <text x="115" y="85" font-size="12" fill="#ef4444">a⃗ = (3, 4)</text>
        <line x1="50" y1="170" x2="110" y2="170" stroke="#3b82f6" stroke-width="1" stroke-dasharray="3,3"/>
        <line x1="110" y1="170" x2="110" y2="90" stroke="#10b981" stroke-width="1" stroke-dasharray="3,3"/>
        <text x="80" y="185" font-size="12" fill="#3b82f6">3</text>
        <text x="120" y="130" font-size="12" fill="#10b981">4</text>
      </svg>
    `,
    options: ["\\(5\\)", "\\(7\\)", "\\(\\sqrt{7}\\)", "\\(12\\)"],
    correctAnswer: 0,
    explanation: "向量長度公式：\\(|\\vec{a}| = \\sqrt{3^2 + 4^2} = \\sqrt{9 + 16} = \\sqrt{25} = 5\\)",
    explanationEn: "Vector magnitude formula: \\(|\\vec{a}| = \\sqrt{3^2 + 4^2} = \\sqrt{9 + 16} = \\sqrt{25} = 5\\)",
    difficulty: "medium",
    topic: "向量",
    hasMath: true,
    hasSvg: true
  },
  {
    id: 9,
    question: "若 \\(\\cos \\theta = \\frac{1}{2}\\)，且 \\(0° ≤ \\theta ≤ 90°\\)，求 \\(\\theta\\) 的值：",
    questionEn: "If \\(\\cos \\theta = \\frac{1}{2}\\) and \\(0° ≤ \\theta ≤ 90°\\), find the value of \\(\\theta\\):",
    options: ["\\(60°\\)", "\\(30°\\)", "\\(45°\\)", "\\(90°\\)"],
    correctAnswer: 0,
    explanation: "\\(\\cos 60° = \\frac{1}{2}\\)，這是基本三角函數值",
    explanationEn: "\\(\\cos 60° = \\frac{1}{2}\\), this is a fundamental trigonometric value",
    difficulty: "easy",
    topic: "三角函數",
    hasMath: true
  },
  {
    id: 10,
    question: "平行四邊形的對角線互相平分。若對角線長度分別為 8 和 6，求平行四邊形的面積：",
    questionEn: "The diagonals of a parallelogram bisect each other. If the diagonal lengths are 8 and 6 respectively, find the area of the parallelogram:",
    svgDiagram: `
      <svg width="280" height="200" viewBox="0 0 280 200">
        <polygon points="50,150 180,150 230,80 100,80" fill="none" stroke="#3b82f6" stroke-width="2"/>
        <line x1="50" y1="150" x2="230" y2="80" stroke="#ef4444" stroke-width="2" stroke-dasharray="5,5"/>
        <line x1="180" y1="150" x2="100" y2="80" stroke="#10b981" stroke-width="2" stroke-dasharray="5,5"/>
        <circle cx="140" cy="115" r="3" fill="#f59e0b"/>
        <text x="145" y="120" font-size="12" fill="#f59e0b">交點</text>
        <text x="135" y="140" font-size="12" fill="#ef4444">8</text>
        <text x="120" y="100" font-size="12" fill="#10b981">6</text>
      </svg>
    `,
    options: ["面積無法僅由對角線長度確定", "\\(24\\)", "\\(48\\)", "\\(12\\)"],
    correctAnswer: 0,
    explanation: "平行四邊形的面積需要知道對角線之間的夾角，僅有對角線長度無法確定面積",
    explanationEn: "The area of a parallelogram requires knowing the angle between diagonals; diagonal lengths alone are insufficient",
    difficulty: "hard",
    topic: "平行四邊形",
    hasMath: true,
    hasSvg: true
  }
  // Additional questions 11-30 would continue with similar complexity and variety...
]; 